import { supabase } from "./supabaseClient";

// Frozen copy of the file server's sanitizeSegment and of public.legacy_build_key
// (004). Only for resolving pre-004 links by name; everything else uses IDs.
export const legacyKey = (name = "") =>
  String(name).trim()
    .replace(/\\/g, "/").replace(/\.\./g, "").replace(/^\/+/, "")
    .replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_\-./]/g, "").replace(/\//g, "_")
  || "_UnknownProject";

const BUILD_COLS = "id,project_id,key,label,streampixel_app_id,server,maya_enabled,status";

export async function fetchBuild(buildId) {
  const { data, error } = await supabase.from("builds").select(BUILD_COLS).eq("id", buildId).maybeSingle();
  if (error) throw error;
  return data;
}

// ponytail: legacy links only (/gallery, old ?build=<name> walkthrough links). Delete with 005.
export async function findBuildByLegacyName(name) {
  if (!name) return null;
  const { data, error } = await supabase.from("builds").select(BUILD_COLS)
    .in("key", [name, legacyKey(name)]).limit(1);
  if (error) throw error;
  return data?.[0] || null;
}

// LIKE treats % and _ as wildcards and \ as their escape; make all three
// literal so a legacy name like "India_Enterprise" matches only itself.
export const escapeLike = (s) => String(s).replace(/[\\%_]/g, "\\$&");

export async function findProjectBySlotName(name) {
  if (!name) return null;
  const { data, error } = await supabase.from("projects").select("id")
    .ilike("project_slot_name", escapeLike(name)).limit(1);
  if (error) throw error;
  return data?.[0] || null;
}
